module.exports = __webpack_public_path__ + "static/media/6780.2169e887.jpg";